module.exports = __webpack_public_path__ + "img/borescope_protoype2_shadow.ccc3ce27.png";